// extracted by mini-css-extract-plugin
module.exports = {"builderWrapper":"ImageInfoBanner_builderWrapper__YyRbb"};